/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ customerName: NonNullable<unknown>, amount: NonNullable<unknown> }} Station_New_Order_ToastInputs */

const vi_station_new_order_toast = /** @type {(inputs: Station_New_Order_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Có đơn hàng của ${i?.customerName}. Tổng số tiền: ${i?.amount}`)
};

/**

* @param {Station_New_Order_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_new_order_toast = /** @type {((inputs: Station_New_Order_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_New_Order_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_new_order_toast(inputs)
});